import { DefaultCell } from '../../../cdl/TableBuilder/components/DefaultCell';
import { StyledDefaultTableBodyRow } from '../../../cdl/TableBuilder/components/StyledDefaultTableBodyRow';
import { formatNumber } from '../../helpers/formatNumber.helper';
import { formatPrice } from '../../helpers/formatPrice.helper';
import { formatTotalPrice } from '../../helpers/formatTotal.helper';
import { Characters } from '../../helpers/unicode.helper';
import { useEnums } from '../../hooks/useEnums';
import { ItemModel } from '../../models/ItemModel';
import { getCellEmphasis } from '../../ReadOnlyProductTable/components/getCellEmphasis';
import { ProductDisplay } from '../../ReadOnlyProductTable/components/ProductDisplay';

interface ItemRowProps {
    item: ItemModel;
    tableRowIndex: number;
    showPrices: boolean;
}

export const ItemRow = ({ item, tableRowIndex, showPrices }: ItemRowProps) => {
    const { getHumanReadableValue } = useEnums();

    return (
        <StyledDefaultTableBodyRow
            grow={true}
            alternateRowColors={true}
            active={false}
            selectable={false}
            disabled={item.deleted}
        >
            <DefaultCell numeric>{tableRowIndex + 1}</DefaultCell>
            <DefaultCell width="35%" truncate={false}>
                <ProductDisplay item={item} />
            </DefaultCell>
            <DefaultCell emphasis={getCellEmphasis(item.changes.packTypeChanged)}>
                {getHumanReadableValue('packType', item.packType)}
            </DefaultCell>
            <DefaultCell emphasis={getCellEmphasis(item.changes.unitSizeChanged)} numeric>
                {formatNumber({ number: item.unitSize, maximumFractionDigits: 3 })}
            </DefaultCell>
            <DefaultCell emphasis={getCellEmphasis(item.changes.unitsChanged)} numeric>
                {item.units ? formatNumber({ number: item.units }) : Characters.EN_DASH}
            </DefaultCell>
            <DefaultCell numeric>
                {item.volume ? formatNumber({ number: item.volume, maximumFractionDigits: 3 }) : Characters.EN_DASH}
            </DefaultCell>
            <DefaultCell emphasis={getCellEmphasis(item.changes.unitChanged)}>
                {getHumanReadableValue('productUnit', item.unit)}
            </DefaultCell>
            {showPrices ? (
                <DefaultCell emphasis={getCellEmphasis(item.changes.priceChanged)} numeric>
                    {item.isCompleteWithPrices() ? formatPrice(item.price!) : Characters.EN_DASH}
                </DefaultCell>
            ) : null}
            {showPrices ? (
                <DefaultCell numeric>
                    {item.isCompleteWithPrices() ? formatTotalPrice(item.total) : Characters.EN_DASH}
                </DefaultCell>
            ) : null}
        </StyledDefaultTableBodyRow>
    );
};
